import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AuthService, SessionUser } from './auth.service';

export interface ImpersonateUserListItem {
  ID: string;
  email: string;
  name: string;
}

@Injectable({ providedIn: 'root' })
export class ImpersonateApiService {
  private readonly baseUrl = (environment.apiUrl || '').replace(/\/+$/u, '');

  constructor(private http: HttpClient, private authService: AuthService) {}

  getUsers(): Observable<ImpersonateUserListItem[]> {
    return this.http.get<any>(`${this.baseUrl}/webapp/impersonate/users`, {
      headers: this.authService.getRealUserAuthHeaders()
    }).pipe(map(r => r?.payload ?? r ?? []));
  }

  impersonateUser(userId: string): Observable<SessionUser> {
    return this.http.post<any>(`${this.baseUrl}/webapp/impersonate/${userId}`, {}, {
      headers: this.authService.getRealUserAuthHeaders()
    }).pipe(map(r => r?.payload ?? r));
  }
}
